var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{class:'main'},[_c('h1',[_vm._v(_vm._s(_vm.$t('project_details.prepayment_title')))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('project_details.prepayment_description'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }